import { render } from "./Canvas.vue?vue&type=template&id=f09a1e98&scoped=true"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"

import "./Canvas.vue?vue&type=style&index=0&id=f09a1e98&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-f09a1e98"

export default script